<nav class="pcoded-navbar" pcoded-header-position="relative">
    <div class="sidebar_toggle"><a href="#"><i class="icon-close icons"></i></a></div>
    <div class="pcoded-inner-navbar main-menu">
        <div class="">
            <div class="main-menu-header">
                <img [src]="perfil.imagenPerfilBase64" alt="Foto de perfil" class="perfil-img img-40" 
                    (error)="perfil.imagenPerfilUrl='assets/images/user.png'">
                <div class="user-details" style="cursor: default !important; ">
                    <span id="more-details" style="cursor: default !important; ">{{user.nombre }} {{ user.sNombre }}
                    </span>
                </div>
            </div>

            <div class="main-menu-content">
                <ul>
                    <li class="more-details">
                        <a href="#" (click)="cerrarSesion()"><i class="ti-layout-sidebar-left"></i>Cerrar
                            Sesi&oacute;n</a>
                    </li>
                </ul>
            </div>
        </div>

        <ul class="pcoded-item pcoded-left-item">
            <li class="">
                <a [routerLink]="['/v2']">
                    <span class="pcoded-micon"><i class="ti-home"></i></span>
                    <span class="pcoded-mtext" data-i18n="nav.dash.main">PANEL INICIAL</span>
                    <span class="pcoded-mcaret"></span>
                </a>
            </li>
            <li class="pcoded-hasmenu" *ngFor="let menu of user.menu">
                <a href="javascript:void(0)">
                    <span class="pcoded-micon"><i class="{{menu.icono}}"></i></span>
                    <span class="pcoded-mtext" data-i18n="nav.page_layout.main">{{menu.modulo}}</span>
                    <span class="pcoded-mcaret"></span>
                </a>
                <ul class="pcoded-submenu">
                    <li *ngFor="let submenu of user.subMenu">
                        <a [routerLink]="[submenu.acceso]" *ngIf="submenu.modulo === menu.modulo">
                            <span class="pcoded-micon"><i class="icon-pie-chart"></i></span>
                            <span class="pcoded-mtext">{{submenu.seccion}}</span>
                            <span class="pcoded-mcaret"></span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>
